import { IFilterElement } from "@saleor/components/Filter";
import { findInEnum, findValueInEnum, maybe, parseBoolean } from "@saleor/misc";
import {
  CommentParentTypeEnum,
  CommentSourceTypeEnum,
  InstagramCommentFilterInput
} from "@saleor/types/globalTypes";
import {
  createFilterTabUtils,
  createFilterUtils,
  dedupeFilter,
  getMultipleEnumValueQueryParam,
  getSingleValueQueryParam
} from "@saleor/utils/filters";

import {
  InsCommentFilterKeys,
  InsCommentListFilterOpts
} from "../../components/InsCommentListPage/filters";
import {
  InsCommentListUrlFilters,
  InsCommentListUrlFiltersEnum,
  InsCommentListUrlFiltersWithMultipleValuesEnum,
  InsCommentListUrlQueryParams
} from "../../urls";
export const COMMENT_FILTERS_KEY = "commentFilters";

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<InsCommentListUrlFilters>(COMMENT_FILTERS_KEY);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  InsCommentListUrlQueryParams,
  InsCommentListUrlFilters
>(InsCommentListUrlFiltersEnum);
export function getFilterQueryParam(
  filter: IFilterElement<InsCommentFilterKeys>
): InsCommentListUrlFilters {
  const { name } = filter;
  switch (name) {
    case InsCommentFilterKeys.isVisible:
      return getSingleValueQueryParam(
        filter,
        InsCommentListUrlFiltersEnum.isVisible
      );
    case InsCommentFilterKeys.parentType:
      return getMultipleEnumValueQueryParam(
        filter,
        InsCommentListUrlFiltersWithMultipleValuesEnum.parentType,
        CommentParentTypeEnum
      );
    case InsCommentFilterKeys.source:
      return getMultipleEnumValueQueryParam(
        filter,
        InsCommentListUrlFiltersWithMultipleValuesEnum.source,
        CommentSourceTypeEnum
      );
  }
}
export function getFilterVariables(
  params: InsCommentListUrlFilters
): InstagramCommentFilterInput {
  return {
    isVisible:
      params.isVisible !== undefined
        ? parseBoolean(params.isVisible, false)
        : undefined,
    parentType: maybe(() =>
      params.parentType.map(parentType =>
        findInEnum(parentType, CommentParentTypeEnum)
      )
    ),
    source: maybe(() =>
      params.source.map(source => findInEnum(source, CommentSourceTypeEnum))
    ),
    search: params.query
  };
}

export function getFilterOpts(
  params: InsCommentListUrlFilters
): InsCommentListFilterOpts {
  return {
    isVisible: {
      active: params.isVisible !== undefined,
      value: maybe(() => parseBoolean(params.isVisible, true))
    },
    parentType: {
      active: maybe(() => params.parentType !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.parentType.map(status =>
              findValueInEnum(status, CommentParentTypeEnum)
            )
          ),
        []
      )
    },
    source: {
      active: maybe(() => params.source !== undefined, false),
      value: maybe(
        () =>
          dedupeFilter(
            params.source.map(status =>
              findValueInEnum(status, CommentSourceTypeEnum)
            )
          ),
        []
      )
    }
  };
}
